import { CompatibilityService as SharedCompatibilityService } from '@amira-rnd/student-shared-services/dist/services';
import { getUserData } from './API';

/**
 * Singleton service for browser compatibility checks.
 * Wraps the SharedCompatibilityService to provide a consistent interface.
 */
class CompatibilityService {
  constructor() {
    if (CompatibilityService.instance) {
      return CompatibilityService.instance;
    }

    this.sharedCompatibilityService = new SharedCompatibilityService();
    CompatibilityService.instance = this;
  }

  /**
   * Checks browser compatibility using the shared service.
   * @returns {boolean} The result from SharedCompatibilityService.checkBrowser()
   */
  checkBrowser() {
    const allowedIpadBrowsers = getUserData().allowedIpadBrowsers;
    return this.sharedCompatibilityService.checkBrowser(allowedIpadBrowsers);
  }
}

// Create and export a single instance
const compatibilityService = new CompatibilityService();

export default compatibilityService;